export enum UIConstants {
  INVALID_COUNTRY_ERROR = 'Please choose a valid shipping Country',
  INVALID_STATE_ERROR = 'Please choose a valid shipping State or Province',
  CARD_NOT_ACCEPTED_MESSAGE = '{0} is not able to be used as payment. Please complete your order using a different card type.',
  CARD_NUMBER_INVALID_MESSAGE = 'Please enter a valid credit card number.',
  CARD_PROCESSING_OFFLINE = 'Credit card processing is offline.',
  CARD_PROCESSING_GENERIC_ERROR = 'Card processing error.',
  CARD_AUTHENTICATION_ERROR = 'Card authentication error.',
  CHOOSE_PAYMENT_METHOD = 'Please choose a payment method.',
  PROMPT_DIFFERENT_PAYMENT_METHOD = 'Please try a different payment method.',
  PROMPT_DIFFERENT_PAYMENT_METHOD_OR_RETRY = 'Please try again or select a different payment method.',
  PCI_FAILURE_MESSAGE = 'Unable to acquire credit card token.',
  TOKEN_FAILURE_MESSAGE = 'Sorry, unable to process credit card at this time.',
  PROMPT_DIFFERENT_CARD = 'Please try a different card.',
  PROMPT_TRY_AGAIN = 'Please try again.',
  NO_SAVED_PAYMENT_CARDS = 'No saved payment cards found',
  GENERAL_FORM_ERROR = 'Oops, some fields require attention below',
  EMPTY_BILLING_ADDRESS = 'Please select a billing address',
  INVALID_CARD_NUMBER = 'Card number is not valid',
  EMPTY_CARD_NUMBER = 'Card number cannot be empty',
  INVALID_EXP_DATE = 'Expiration date is not valid',
  EMPTY_EXP_DATE = 'Expiration date cannot be empty',
  PAST_EXP_DATE = 'Expiry date must be in the future',
  INVALID_CVV = 'CVV is not valid',
  EMPTY_CVV = 'CVV cannot be empty',
  WRONG_LENGTH_CVV = 'Must be 3 or 4 numbers',
  WRONG_LENGTH_GIFT_CARD = 'Gift Card code must be 13 characters long.',
  NO_BLANKS_OR_SPECIAL_CHARACTERS = 'Cannot contain blank spaces or special characters',
  PAYPAL_CLICK_TO_CONTINUE = 'Please click a PayPal button to continue.',
  AMAZON_PAY_CLICK_TO_CONTINUE = 'Please click the Amazon Pay button to continue.',
  STATE_DEFAULT_VALUE_MESSAGE = 'Please select',
  CVV_TOOL_TIP = 'Enter the security code on the back of your card. For Amex, on the front of your card.',
  DISABLED_ADDRESS_WITH_PAYPAL_TOOL_TIP = 'The entered address is connected to your PayPal account and cannot be edited here',
  CALCULATED_AT_PAYMENT = 'Calculated at Payment',
  RECAPTCHA_ERROR = 'There was an error with reCAPTCHA. Please try again!',
}

export enum DefaultValues {
  DEFAULT_PAYMENT_METHOD_ID = '-1',
  DEFAULT_BILLING_ADDRESS_METHOD_ID = '0',
  DEFAULT_SHIPPING_COUNTRY = 'United States',
  DEFAULT_SHIPPING_SYSTEM = 'DEFAULT',
  DEFAULT_LABEL_TEXT = 'Order Comments',
}

export enum APIValues {
  PAYPAL_METHOD = 'PayPal Express Upgrade',
  AMAZON_PAY_METHOD = 'Amazon Pay',
  CREDIT_CARD_METHOD = 'Credit Card',
  ECHECK_METHOD = 'Electronic Check',
  STRIPE_METHOD = 'VolusionPayments',
}

export enum SiteLimitationKeys {
  STRIPE_SERVICE_ENABLED = 'Feature_Stripe_Service_Enabled',
}

export enum SupportedCreditCardTypes {
  CARD_TYPE_VISA = 'Visa',
  CARD_TYPE_MASTER_CARD = 'MasterCard',
  CARD_TYPE_DISCOVER = 'Discover',
  CARD_TYPE_AMERICAN_EXPRESS = 'American Express',
  CARD_TYPE_DINERS_CLUB = 'Diners Club',
  CARD_TYPE_JCB = 'JCB',
  CARD_TYPE_ALELO = 'Alelo',
  CARD_TYPE_ALIA = 'Alia',
  CARD_TYPE_CABAL = 'Cabal',
  CARD_TYPE_CARNET = 'Carnet',
  CARD_TYPE_CONFIABLE = 'Confiable',
  CARD_TYPE_DANKORT = 'Dankort',
  CARD_TYPE_ELO = 'Elo',
  CARD_TYPE_MAESTRO = 'Maestro',
  CARD_TYPE_NARANJA = 'Naranja',
  CARD_TYPE_OLIMPICA = 'Olimpica',
  CARD_TYPE_SODEXO = 'Sodexo',
  CARD_TYPE_VR = 'VR',
}

export enum SpreedlyValues {
  CARD_TOKEN_PROVIDER = 'SPREEDLY',
  SCRIPT_URL = 'https://core.spreedly.com/iframe/iframe-v1.min.js',
  CARD_NUMBER_ID = 'spreedly-card-number',
  CVV_ID = 'spreedly-cvv',
  FIELD_STYLE = 'font-size: 16px; width: 100%; height: 50px; padding-left: 1rem;',
  CARD_TYPE_VISA = 'visa',
  CARD_TYPE_MASTER_CARD = 'master',
  CARD_TYPE_DISCOVER = 'discover',
  CARD_TYPE_AMERICAN_EXPRESS = 'american_express',
  CARD_TYPE_DINERS_CLUB_1 = 'diners_club',
  CARD_TYPE_DINERS_CLUB_2 = 'diners',
  CARD_TYPE_JCB = 'jcb',
  CARD_TYPE_ALELO = 'alelo',
  CARD_TYPE_ALIA = 'alia',
  CARD_TYPE_CABAL = 'cabal',
  CARD_TYPE_CARNET = 'carnet',
  CARD_TYPE_CONFIABLE = 'confiable',
  CARD_TYPE_DANKORT = 'dankort',
  CARD_TYPE_ELO = 'elo',
  CARD_TYPE_MAESTRO = 'maestro',
  CARD_TYPE_NARANJA = 'naranja',
  CARD_TYPE_OLIMPICA = 'olimpica',
  CARD_TYPE_SODEXO = 'sodexo',
  CARD_TYPE_VR = 'vr',
  SPREEDLY_3DS_SUCCEEDED = 'succeeded',
  SPREEDLY_3DS_PENDING = 'pending',
  SPREEDLY_3DS_CHALLENGE = 'challenge',
}

export enum Endpoints {
  PAYPAL_ORDER = '/net/paypalv2/order',
  PAYPAL_CREATE_PAYMENT = '/net/PayPalRestCreatePaymentHandler.ashx',
  PAYPAL_GET_PAYMENT_DETAILS = '/net/PayPalRestGetPaymentDetailsHandler.ashx?id=',
  PAYPAL_GET_CLIENT_TOKEN = '/net/PayPalAcpGetClientTokenHandler.ashx',
  PAYPAL_PPCP_ACTIVE = '/net/PayPalV1IsActivePpcp.ashx',
  ADDRESS_VERIFICATION = '/addressverification',
  ADDRESS_VALIDATION = '/net/microservices/address',
  AUTOCOMPLETE_MATCHES = '/autocomplete',
  AUTOCOMPLETE_DETAILS = '/autocomplete/details',
  NEW_CUSTOMER = '/api/v1/users',
  CURRENT_CUSTOMER = '/api/v1/users/current',
  CURRENT_CUSTOMER_SHIPPING_ADDRESSES = '/api/v1/users/current/shippingAddresses',
  CURRENT_CUSTOMER_BILLING_ADDRESSES = '/api/v1/users/current/billingAddresses',
  CURRENT_CUSTOMER_PAYMENT_PROFILES = '/api/v1/users/current/paymentProfiles',
  LOGIN = `/ajax_receiver.asp?system=login`,
  ENABLED_PAYMENT_METHODS = '/api/v1/payments',
  GIFT_CARDS = '/api/v1/giftcards/',
  RECAPTCHA = `/ajax_receiver.asp?system=recaptcha`,
}

export enum GroupNames {
  SHIPPING_METHOD_GROUP_NAME = 'shippingMethods',
  SHIPPING_ADDRESS_GROUP_NAME = 'shippingAddresses',
}
